import { icon, Icon } from '../lib/fa-icons.js';
import $ from "jquery";
import Widget from "./base.js";
import Keypress from "keypress.js";
import DataFetcher from "../sheets-data-fetcher.js";

//https://docs.google.com/spreadsheets/d/1Lx5G6WjKsZhkl4_4bFtn7MaXWzRTkhp5GeqtUyXEJ0Y/edit#gid=0
export class FilibusterBase extends Widget {
	componentDidMount() {
		this.sheetID = "1Lx5G6WjKsZhkl4_4bFtn7MaXWzRTkhp5GeqtUyXEJ0Y";
		const self = this;

		DataFetcher._emitter.on("response", (data) => {
			if (data.values) {
				let values = data.values;
				self.getColIndices(values[0]);
				//handleData defined on child components, different in each case
				self.handleData(values, self.countPositions(values));
			} else {
				self.setState({ error: true });
			}
		});

		if (!DataFetcher[`data-${this.sheetID}`]) DataFetcher.fetch(this.sheetID);
	}

	getColIndices(head) {
		let obj = {};
		head.forEach((element, index) => {
			obj[element] = index;
		});
		this.indices = obj;
	}

	getCell(row, colName) {
		return row[this.indices[colName]];
	}

	countPositions(data) {
		let supportsElim = 0;
		let openElim = 0;
		let openReform = 0;
		let againstReform = 0;

		data.forEach((row, index) => {
			let position = this.getCell(row, "Position");
			if (position === "Urges eliminating the filibuster") {
				supportsElim++;
			} else if (position === "Open to eliminating the filibuster") {
				openElim++;
			} else if (position === "Open to reforming how the filibuster works") {
				openReform++;
			} else if (
				position === "Against eliminating or reforming the filibuster"
			) {
				againstReform++;
			}
		});

		const positions = {
			supportsElim: supportsElim,
			openElim: openElim,
			openReform: openReform,
			againstReform: againstReform,
		};
		return positions;
	}
}

export class FilibusterMeter extends FilibusterBase {
	handleData(data, positions) {
		this.setState({
			positions: positions,
			data: data,
		});
	}

	embedHeading() {
		return (
			<div className="FilibusterMeter__Heading">
				<div>Democrats' Positions on Filibuster</div>
				<a href={`${document.location.origin}/filibuster`}>
					read more <Icon name="right-long" style="light" />
				</a>
			</div>
		);
	}

	renderContent() {
		if (this.state.error)
			return (
				<div class="FilibusterMeter__Inner --empty">error fetching data</div>
			);
		if (!this.state.positions)
			return <div class="FilibusterMeter__Inner --empty">...fetching...</div>;
		else {
			const positions = this.state.positions;
			return [
				this.props.embed ? this.embedHeading() : null,
				<div
					className={`FilibusterMeter__Inner ${
						this.props.embed ? "--embed" : ""
					}`}
				>
					<div
						className="FilibusterMeter__Section --supportsElim"
						style={`width: ${(positions.supportsElim / 50) * 100}%`}
					>
						<div
							className={`FilibusterMeter__SectionFill --supportsElim ${
								this.props.embed ? "--embed" : ""
							}`}
						></div>
						<div
							style={
								window.is_mobile || this.props.embed ? "display: none" : ""
							}
							className={`FilibusterMeter__SectionCount`}
						>
							{positions.supportsElim} urge eliminating the filibuster
						</div>
					</div>
					<div
						className="FilibusterMeter__Section --openElim"
						style={`width: ${(positions.openElim / 50) * 100}%`}
					>
						<div
							className={`FilibusterMeter__SectionFill --openElim ${
								this.props.embed ? "--embed" : ""
							}`}
						></div>
						<div
							style={
								window.is_mobile || this.props.embed ? "display: none" : ""
							}
							className={`FilibusterMeter__SectionCount`}
						>
							{positions.openElim} open to eliminating the filibuster
						</div>
					</div>
					<div
						className="FilibusterMeter__Section --openReform"
						style={`width: ${(positions.openReform / 50) * 100}%`}
					>
						<div
							className={`FilibusterMeter__SectionFill --openReform ${
								this.props.embed ? "--embed" : ""
							}`}
						></div>
						<div
							style={
								window.is_mobile || this.props.embed ? "display: none" : ""
							}
							className={`FilibusterMeter__SectionCount`}
						>
							{positions.openReform} open to reforming how the filibuster works
						</div>
					</div>
					<div
						className="FilibusterMeter__Section --againstReform"
						style={`width: ${(positions.againstReform / 50) * 100}%`}
					>
						<div
							className={`FilibusterMeter__SectionFill --againstReform ${
								this.props.embed ? "--embed" : ""
							}`}
						></div>
						<div
							style={
								window.is_mobile || this.props.embed ? "display: none" : ""
							}
							className={`FilibusterMeter__SectionCount ${
								this.props.ticker ? "--ticker" : ""
							}`}
						>
							{positions.againstReform}
							{this.props.embed
								? " against reform"
								: " against eliminating or reforming the filibuster"}
						</div>
					</div>
				</div>,
			];
		}
	}
}

export class FilibusterTickerWidget extends FilibusterBase {
	handleData(data, positions) {
		const self = this;
		this.setState(
			{
				count: positions.againstReform,
				data: data,
			},
			() => {
				let numbers = "";
				for (let index = 0; index <= self.state.count; index++) {
					numbers += `<span style='--ticker-transform-value:-${
						this.state.count * 100
					}%;'>${index}</span>`;
				}
				$(".js_filibuster-ticker-count").html(numbers);
			}
		);
	}
	renderContent() {
		return (
			<div class="row">
				<div class="--span-12">
					<div className="FilibusterTicker">
						<div class="FilibusterTicker__Inner">
							<div class="FilibusterTicker__Count">
								<div class="js_filibuster-ticker-count">
									<span>0</span>
								</div>
							</div>
							<div class="FilibusterTicker__Text">
								Senators away from
								<br />
								changing the filibuster
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export class FilibusterBubblesWidget extends FilibusterBase {
	handleData(data, positions) {
		//get width of container, so we can make the bubbles a proportion of that
		var containerWidth = $(".FilibusterBubblesWidget").width();

		this.setState(
			{
				data: data,
				positions: positions,
				containerWidth: containerWidth,
				active: "againstReform",
			},
			() => {
				//https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
				//animate heading border when scrolled into view
				// define an observer instance
				var observer = new IntersectionObserver(onIntersection, {
					root: null, // default is the viewport
					threshold: 0.5, // 50% of target's visible area. Triggers "onIntersection"
				});

				// callback is called on intersection change
				function onIntersection(entries, opts) {
					entries.forEach((entry) => {
						entry.target.classList.add("--animate", entry.isIntersecting);
						//stop observing after class is added
						observer.observe(
							document.querySelector(".FilibusterBubbles__HeadshotsHeading")
						);
					});
				}

				// Use the observer to observe an element
				observer.observe(
					document.querySelector(".FilibusterBubbles__HeadshotsHeading")
				);
			}
		);
	}

	changeActivePosition(position) {
		this.setState({ activePosition: position });
	}

	//headshots with tooltips
	renderHeadshots() {
		let headingText = "";
		if (this.state.active === "againstReform")
			headingText = "Who opposes changing how the filibuster works?";
		if (this.state.active === "openReform")
			headingText =
				"Who wants to keep the filibuster, but change how it works?";
		if (this.state.active === "openElim")
			headingText = "Who is open to getting rid of the filibuster outright?";
		if (this.state.active === "supportsElim")
			headingText = "Who wants to get rid of the filibuster outright?";

		const self = this;
		function headshots() {
			return self.state.data.map((row) => {
				let pos = self.getCell(row, "Position");
				if (pos === "Against eliminating or reforming the filibuster")
					pos = "againstReform";
				if (pos === "Open to reforming how the filibuster works")
					pos = "openReform";
				if (pos === "Open to eliminating the filibuster") pos = "openElim";
				if (pos === "Urges eliminating the filibuster") pos = "supportsElim";

				//image filename
				let filename =
					self.getCell(row, "First") + "-" + self.getCell(row, "Last") + ".jpg";
				filename = filename.replace(" ", "");

				const str = self.getCell(row, "strength");

				if (self.state.active === pos) {
					return (
						<div
							className={`FilibusterBubbles__Headshot --${pos} --${self.getCell(
								row,
								"strength"
							)}`}
						>
							<img
								src={`/wp-content/themes/tpm25/assets/images/filibuster-headshots/${filename}`}
								alt={self.getCell(row, "Name")}
							/>
							<div
								className={`FilibusterBubbles__HeadshotTip --${
									str ? str : "small"
								}`}
							>
								<div className="FilibusterBubbles__HeadshotTipName">
									{self.getCell(row, "Name")}
								</div>
								<p className="FilibusterBubbles__HeadshotTipSummary">
									{self.getCell(row, "Summary")}
								</p>
							</div>
						</div>
					);
				}
			});
		}

		return (
			<div class={`FilibusterBubbles__Headshots --${this.state.active}`}>
				<div
					className={`FilibusterBubbles__HeadshotsHeading --${this.state.active}`}
				>
					{headingText}
				</div>
				<div
					className={`FilibusterBubbles__HeadshotsInner --${this.state.active}`}
				>
					{headshots()}
				</div>
			</div>
		);
	}

	toggle(group) {
		if (group === this.state.active) return;
		this.setState(
			{
				active: group,
			},
			() => {
				const yOffset = -90;
				const element = document.querySelector(
					".FilibusterBubbles__HeadshotsHeading"
				);
				const y =
					element.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: "smooth" });
			}
		);
	}

	makeBubble(group, text) {
		return (
			<div
				className={`FilibusterBubbles__Bubble --${group} ${
					this.state.active === group ? "--active" : ""
				}`}
				onClick={() => {
					this.toggle(group);
				}}
				style={{
					width:
						((this.state.positions[group] * 2) / 100) *
							this.state.containerWidth +
						"px",
					height:
						((this.state.positions[group] * 2) / 100) *
							this.state.containerWidth +
						"px",
				}}
			>
				<b>{this.state.positions[group]}</b>
				{text}
			</div>
		);
	}

	//bubbles with numbers, control which headshots are displayed
	renderBubbles() {
		return (
			<div class="FilibusterBubbles__Bubbles">
				{this.makeBubble("supportsElim", "The Nukers")}
				{this.makeBubble("openElim", "The Nuke-Curious")}
				{this.makeBubble("openReform", "The Reformers")}
				{this.makeBubble("againstReform", "The Status Quo Sect")}
			</div>
		);
	}

	renderContent() {
		if (!this.state.positions) return;
		if (window.is_mobile) return [this.renderBubbles(), this.renderHeadshots()];
		return [this.renderHeadshots(), this.renderBubbles()];
	}
}

export class FilibusterTable extends FilibusterBase {
	handleData(data, positions) {
		this.setState({ data: data }, this.setupDataTable);
	}

	componentWillMount() {
		this.keypress = new Keypress.Listener();

		this.keypress.register_combo({
			keys: "esc",
			// is_solitary: true,
			is_exclusive: true,
			is_unordered: true,
			on_keyup: (evt) => {
				this.hideTooltips();
			},
		});
	}

	setupDataTable() {
		$("#FilibusterTable").DataTable({
			paging: false,
			order: [[1, "asc"]],
			info: false,
			stripeClasses: [], //disable stripes
			columnDefs: [{ targets: "no-sort", orderable: false }],
			searching: false,
		});
	}

	toggleTooltip(tip, row) {
		this.hideTooltips();

		const tableOffset = $("#FilibusterTable_wrapper").offset().top;

		const $row = $("#" + row);
		const rowOffset = $row.offset().top + $row.height();

		const diff = Math.abs(rowOffset - tableOffset);

		$("#" + tip).css("top", diff + "px");

		// const parentTop = parentElem.getBoundingClientRect().top //  parent's top distance from the top of the viewport;
		// const currentChildTop = childElement.getBoundingClientRect().top //  child's top distance from the top of the viewport;

		//cant use react state, dont wanna re-render
		if (!this.active) {
			this.active = tip;
			$("#" + tip).addClass("--active");
		} else {
			this.active = null;
			$("#" + tip).removeClass("--active");
		}
	}

	hideTooltips() {
		// if (evt.target.classList.contains('FilibusterTable__TooltipControl')) return
		// if (evt.target.classList.contains('FilibusterTable__Tooltip')) return

		this.active = null;
		$(".FilibusterTable__Tooltip").each(function () {
			$(this).removeClass("--active");
		});
	}

	renderTableRows() {
		let tableRows = [];
		this.state.data.forEach((row, index) => {
			const sortName =
				this.getCell(row, "Last") + "-" + this.getCell(row, "First");

			//get the "what they said" text formatted
			//$$ delimits start of each quote item
			let said = this.getCell(row, "What S/He Has Said").split("$$");
			const quotes = said.map((quote) => {
				if (quote.length < 1) return;
				if (quote.indexOf("~") < 1) return <li>{quote}</li>;
				//tilde delimits start of link for quote s
				const parts = quote.split("~");
				return (
					<li>
						<a href={parts[1]} target="_blank">
							{parts[0]} <Icon name="up-right-from-square" style="regular" />
						</a>
					</li>
				);
			});

			//generate classes & sorting ranks for position blocks
			let pos = this.getCell(row, "Position");
			// let posClass = pos.split(' ').map((word) => {
			//   return word[0].toUpperCase() + word.slice(1)
			// })
			let posClass = pos.split(" ");
			posClass = posClass.join("");

			let sortPos;
			switch (pos) {
				case "Against eliminating or reforming the filibuster":
					sortPos = 1;
					pos = "Status Quo Sect";
					break;
				case "Open to reforming how the filibuster works":
					sortPos = 2;
					pos = "Reformer";
					break;
				case "Open to eliminating the filibuster":
					sortPos = 3;
					pos = "Nuke-Curious";
					break;
				case "Urges eliminating the filibuster":
					sortPos = 4;
					pos = "Nuker";
					break;
				default:
					break;
			}

			//image filename
			let filename =
				this.getCell(row, "First") + "-" + this.getCell(row, "Last") + ".jpg";
			filename = filename.replace(" ", "");

			tableRows.push(
				<tr id={`row${index}`}>
					<td data-sort={sortName}>{this.getCell(row, "Name")}</td>
					<td data-sort={sortPos}>
						<div class={`FilibusterTable__PositionBlock --${posClass}`}>
							{pos}
						</div>
					</td>
					<td>
						<div
							class="FilibusterTable__TooltipControl"
							onclick={() => {
								this.toggleTooltip("tip" + index, "row" + index);
							}}
						>
							What they said <Icon name="chevron-down" style="light" />
						</div>
					</td>
					<div id={`tip${index}`} class="FilibusterTable__Tooltip">
						<div class="FilibusterTable__TooltipInner">
							<div
								class="FilibusterTable__TooltipClose"
								onClick={(evt) => {
									this.hideTooltips(evt);
								}}
							>
								<Icon name="xmark" style="light" />
							</div>
							<img
								class="FilibusterTable__TooltipImg"
								src={`/wp-content/themes/tpm25/assets/images/filibuster-headshots/${filename}`}
								alt={this.getCell(row, "Name")}
							/>
							<ul class="FilibusterTable__TooltipText">{quotes}</ul>
						</div>
					</div>
				</tr>
			);
		});
		return tableRows;
	}

	renderContent() {
		if (!this.state.data) return;
		return (
			<table id="FilibusterTable" class="hover">
				<thead>
					<tr>
						<th>
							Name <Icon name="sort" style="duotone" />
							<Icon name="sort-up" style="duotone" />
							<Icon name="sort-down" style="duotone" />
						</th>
						<th>
							Position <Icon name="sort" style="duotone" />
							<Icon name="sort-up" style="duotone" />
							<Icon name="sort-down" style="duotone" />
						</th>
						<th class="no-sort">Details</th>
					</tr>
				</thead>
				<tbody>{this.renderTableRows()}</tbody>
			</table>
		);
	}
}
